import reduxFetch from 'react-redux-fetch';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import { TARGETS_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const TargetsService = ComposedComponent =>
  reduxFetch([
    {
      resource: TARGETS_RESOURCE,
      method: 'get',
      request: (id, organisationRoleId) => ({
        url: addParametersToUri(apiRoutes.communityMembers(id), { organisationRoleId }),
      }),
    },
  ])(ComposedComponent);

export default TargetsService;
